export default "__VITE_ASSET__DgNzL6MR__"